const carouselItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20visual%20with%20royal%20court%20scene%2C%20warm%20golden%20amber%20lighting%2C%20traditional%20costumes%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20epic%20historical%20drama%20aesthetic&width=600&height=400&seq=crsl-topic-01&orientation=landscape",
    tag: '古装大剧',
    title: '年度古装巨制合集',
    desc: '长安风云录领衔，多部口碑古装剧一次看过瘾',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Modern%20urban%20cityscape%20at%20sunset%20with%20couple%20silhouette%2C%20warm%20romantic%20lighting%2C%20film%20grain%20texture%2C%20cinematic%20aesthetic%2C%20romance%20drama%20visual%20style&width=600&height=400&seq=crsl-topic-02&orientation=landscape",
    tag: '都市情感',
    title: '暖心都市情感剧场',
    desc: '遇见你的那天领衔，都市男女的温暖故事合集',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Suspense%20mystery%20scene%20with%20rainy%20city%20street%20at%20night%2C%20neon%20reflections%2C%20film%20noir%20aesthetic%2C%20cinematic%20composition%2C%20crime%20drama%20visual%20style%2C%20moody%20atmosphere&width=600&height=400&seq=crsl-topic-03&orientation=landscape",
    tag: '悬疑烧脑',
    title: '高能悬疑剧集专场',
    desc: '迷雾追踪领衔，烧脑反转停不下来的好剧合集',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Korean%20drama%20style%20romantic%20scene%20with%20cherry%20blossoms%2C%20soft%20pastel%20lighting%2C%20cinematic%20aesthetic%2C%20Korean%20wave%20drama%20visual%2C%20warm%20spring%20atmosphere&width=600&height=400&seq=crsl-topic-04&orientation=landscape",
    tag: '韩剧精选',
    title: '热门韩剧一次看够',
    desc: '最新高分韩剧合集，浪漫爱情与悬疑佳作齐上线',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Youth%20school%20drama%20visual%20with%20cherry%20blossom%20campus%2C%20bright%20fresh%20lighting%2C%20film%20grain%20texture%2C%20coming%20of%20age%20aesthetic%2C%20warm%20nostalgic%20atmosphere%2C%20cinematic%20composition&width=600&height=400&seq=crsl-topic-05&orientation=landscape",
    tag: '青春校园',
    title: '高甜青春校园剧场',
    desc: '青春不散场，最甜校园偶像剧全集在线看',
  },
  {
    img: "https://readdy.ai/api/search-image?query=American%20TV%20drama%20style%20visual%20with%20New%20York%20skyline%2C%20warm%20cinematic%20lighting%2C%20urban%20drama%20aesthetic%2C%20professional%20TV%20series%20key%20visual%2C%20modern%20city%20atmosphere&width=600&height=400&seq=crsl-topic-06&orientation=landscape",
    tag: '美剧专区',
    title: '高分美剧精选合集',
    desc: '口碑炸裂的经典美剧与新番推荐，原声双语字幕',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热门专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精心策划的追剧专题合集，发现属于你的下一部好剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-950/70 text-background-50 text-xs font-medium backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-950 font-heading mb-1.5 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}